import React from 'react'
import Header from '../header'
import Footer from '../footer'

export default function Websitedevelopment() {
  return (
    <div>
        <Header/>
    <main>
  <style dangerouslySetInnerHTML={{__html: "\n.txtwidth\n{\n\twidth:50%;\n}\n@media screen and (min-width: 680px) {\n  .txtwidth {\n    width:100%;\n  }\n}\n.service-sidebar-area .service-card {\n    margin-bottom: 30px;\n    background-color: #ffffff;\n    -webkit-box-shadow: 0 0 20px 3px rgb(0 0 0 / 5%);\n    box-shadow: 0 0 20px 3px rgb(0 0 0 / 5%);\n}\n.service-sidebar-area .service-details-title {\n    background-color: #2c79ff;\n    color: #ffffff;\n    padding: 15px 20px;\n    margin-bottom: 0;\n}\nul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.service-sidebar-area .service-list ul li {\n    border-bottom: 1px dashed #eeeeee;\n    padding: 15px 20px;\n    font-weight: 500;\n    \n    transition: all 0.5s;\n}\n.service-sidebar-area .service-list ul li i {\n    float: right;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    background-color: #2c79ff;\n    border-radius: 50%;\n    color: #ffffff;\n    font-size: 20px;\n    text-align: center;\n    transition: all 0.5s;\n    position: relative;\n    top: -3px;\n}\n.bx {\n    font-family: boxicons!important;\n    font-weight: 400;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    display: inline-block;\n    text-transform: none;\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n}\n\n\t/* Custom style */\n    .accordion-button::after {\n      background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n      transform: scale(.7) !important;\n    }\n    .accordion-button:not(.collapsed)::after {\n      background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n    }\n" }} />
  <div className="breadcrumb__area include-bg pt-200 pb-150" style={{paddingTop: 50, paddingBottom: 50, backgroundImage:"url(assets/img/breadcrumb/computer1.jpg)"}} data-background="assets/img/breadcrumb/computer1.jpg">
    <div className="container">
      <div className="row">
        <div className="txtwidth" style={{fontSize: 27, fontWeight: 800, color: 'white', paddingBottom: 33, textDecoration: 'underline'}}>Website Development</div>
        <div style={{fontSize: 18, color: 'white', paddingBottom: 33}}>Website development courses are designed to teach individuals how to design, develop, and maintain websites. These courses cover a range of topics such as HTML, CSS, JavaScript, website architecture, and content management systems. Through hands-on training and practical exercises, students develop proficiency in website development tools and techniques. </div>
      </div>
      <div style={{color: '#ffffff', fontSize: 20, fontWeight: 900}}><span>Call Trainer</span><br /><a style={{color:"white"}} href="tel:+91 8976758080"><i className="fa-regular fa-phone" />
          +91 8976758080</a></div>
    </div>
  </div>
  <div className="tp-about__section" style={{paddingTop: 50, paddingBottom: 30}}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div style={{background: '#f3f1ee', padding: 29}}>
            <p style={{borderBottom: '2px solid red', fontSize: 30, fontWeight: 700, paddingBottom: 25}}>Website Development Training</p>
          </div>
          <div className="accordion" id="myAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne" style={{fontWeight: 800, fontSize: 18}}>Website Development</button>									
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#myAccordion">
                <div className="card-body">
                <b>HTML/HTML5</b>
<li>Introduction to HTML/HTML5</li>
<li>HTML Basics</li>
<li>HTML Element</li>
<li>HTML Attributes</li>
<li>HTML Block and Inline Element</li>
<li>HTML Table</li>
<li>HTML Lists</li>
<li>HTML I frame</li>
<li>HTML Form Element</li>
<li>HTML5 New Element</li>
<li>HTML Semantic Non Semantic</li>
<li>HTML5 Audio Video</li>
<li>Html Link</li>
<li>Html Colors</li>
<li>Html Page Title</li>
<li>Html style</li>
<b>CSS/CSS3</b>
<li>CSS Introduction</li>
<li>CSS Types</li>
<li>CSS Selectors</li>
<li>CSS Properties</li>
<li>CSS margin</li>
<li>CSS Padding</li>
<li>CSS text Properties</li>
<li>CSS3 Rounded Corners</li>
<li>CSS3 Border Images</li>
<li>CSS3 Backgrounds</li>
<li>CSS3 Shadow</li>
<li>CSS Fonts</li>
<li>CSS Links</li>
<li>CSS List</li>
<li>CSS Table</li>
<li>CSS Height/width</li>
<b>Java Script</b>
<li>Introduction To JavaScript</li>
<li>JS syntax</li>
<li>JS Statements</li>
<li>JS Comments</li>
<li>JS variables</li>
<li>JS Operators</li>
<li>JS Arithmetic’s</li>
<li>JS Assignments</li>
<li>JS Data Type</li>
<li>JS Function</li>
<li>JS Scope</li>
<li>JS events</li>
<li>JS string Methods</li>
<li>JS math’s Methods</li>
<li>JS Random</li>
<li>JS Array And Array Methods</li>
<li>JS Comparisons</li>
<li>JS Switch</li>
<li>JS Looping</li>
<li>JS break</li>
<li>JS regExp</li>
<li>JS HTML DOM</li>
<li>Dom Event Listener</li>
<li>JS Arrey Method</li>
<li>JS Arrey Sort</li>
<b>Jquery</b>
<li>Jquery Selectors</li>
<li>Jquery HTML</li>
<li>Jquery CSS</li>
<li>Jquery DOM</li>
<b>PHP</b>
<li>PHP Introduction</li>
<li>PHP Install</li>
<li>PHP Syntax</li>
<li>PHP variables</li>
<li>PHP echo/print</li>
<li>PHP Sorting Array</li>
<li>PHP Superglobals</li>
<li>PHP Date Time</li>
<li>PHP File Handling</li>
<li>PHP File Upload</li>
<li>PHP Cookies</li>
<li>PHP Sessions</li>
<li>PHP Data type</li>
<li>PHP String</li>
<li>PHP Constants</li>
<li>PHP Operators</li>
<li>PHP If/Else Statement</li>
<li>PHP Switch</li>
<li>PHP Loops</li>
<li>PHP Function</li>
<li>PHP Array</li>
<li>PHP Array Function</li>
<li>PHP String Function</li>
<li>PHP include/Require</li>
<b>MYSQL</b>
<li>MySQL Create Database</li>
<li>MySQL Create Table</li>
<li>MySQL Insert Data</li>
<li>MySQL Update Date</li>
<li>MySQL Select Data</li>
<li>MySQL JOIN</li>
<li>MySQL Union</li>
<li>MySQL function</li>
<li>MySQL Aliases</li>
<li>MySQL Between</li>
<li>MySQL Order By</li>
<li>MySQL and /or</li>
<li>MySQL Distinct</li>
<li>MySQL Delete Data</li>
<li>MySQL LIKE</li>
<li>MySQL IN</li>
<li>MySQL Count</li>
<li>MySQL Sum</li>
<li>MySQL full join</li>
<li>MySQL Right join</li>
<li>MySQL Left join</li>
<li>MySQL inner join</li>
<b>Bootstrap</b>
<li>Introduction to HTML</li>
<li>Introduction to Bootstrap</li>
<li>Bootstrap Grid System</li>
<li>Bootstrap Grid System - Advanced</li>
<li>Creating Layouts with Bootstrap</li>
<li>Bootstrap CSS - Understanding the CSS</li>
<li>CSS Customization / Skins</li>
<li>CSS Customization / Skins</li>
<li>Responsive Web design with Bootstrap</li>
<li>Single Page Responsive site with Bootstrap</li>
<li>Introduction to LESS and SASS</li>
<li>Customizing Bootstrap3 with LESS</li>
<li>Bootstrap Plug-ins</li>
<li>Bootstrap Layout Components</li>
<b>Bootstrap Layout Components</b>
<li>Glyph icons</li>
<li>Dropdowns</li>
<li>Button Groups</li>
<li>Button Dropdowns</li>
<li>Input Groups</li>
<li>Navs</li>
<li>Navbar</li>
<li>Breadcrumbs</li>
<li>Pagination</li>
<li>Labels</li>
<li>Badges</li>
<li>Jumbo Tron</li>
<li>Page header</li>
<li>Thumbnails</li>
<li>Alerts</li>
<li>Progress bar</li>
<li>Media object</li>
<li>List group</li>
<li>Panels</li>
<li>Responsive embed</li>
<li>Wells</li>
<b>Building Websites with Bootstrap Bootstrap Plug-ins</b>
<li>Transition</li>
<li>Modal</li>
<li>Dropdown</li>
<li>Scroll spy</li>
<li>Tab</li>
<li>Toolti</li>
<li>Full Case Study</li>
<li>Popover</li>
<li>Alert</li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<Footer/>
    </div>
  )
}
